$(function () {
  portfolio_filter();

  // code for modal animation effect
  $(document).on('click', '[data-toggle-class]', function (e) {
    var $self = $(this);
    var attr = $self.attr('data-toggle-class');
    var target = $self.attr('data-toggle-class-target') || $self.attr('data-target');
    var closest = $self.attr('data-target-closest');
    var classes = (attr && attr.split(',')) || '',
      targets = (target && target.split(',')) || Array($self),
      key = 0;
    $.each(classes, function (index, value) {
      var target = closest ? $self.closest(targets[(targets.length == 1 ? 0 : key)]) : $(targets[(targets.length == 1 ? 0 : key)]),
        current = target.attr('data-class'),
        _class = classes[index];
      (current != _class) && target.removeClass(target.attr('data-class'));
      target.addClass(classes[index]);
      target.attr('data-class', _class);
      key++;
    });

    $('[data-toggle="tooltip"]').tooltip();

  });

  // Go to top
  $(".goto-top").on('click', function () {
    $("html, body").animate({ scrollTop: 0 }, 1000);
    return false;
  });

  //Mobile Menu
  $('.menu-trigger').on('click', function () {
    $('body').toggleClass('menu--open');
    nav_height();
    $('.header-main').removeClass('search-show');
  });

  //Nav trigger
  $('.nav-arrow').on('click', function () {
    $(this).parent('li').find('.has-sub-menu').removeClass('sub--open');
    $('.mega-menu-title').removeClass('active');
    $(this).parent().siblings('li.has-sub-menu').removeClass('sub--open').find('ul').slideUp();
    $(this).parent().toggleClass('sub--open').find('ul').first().slideToggle();
  });

  // Search on navigation
  $('.search-btn').on('click', function () {
    $('.header-main').toggleClass('search-show');
    $('body').removeClass('menu--open');
    $('.custom-dropdown-wrap').removeClass('open');
    $('.custom-dropdown-wrap .custom-dropdown').slideUp('fast');
  });

  //for mega menu
  $('.mega-menu-title').on('click', function () {
    if (!$(this).next().hasClass('active')) {
      $('.mega-dropdown-list').removeClass('active');
      $(this).next().addClass('active');
      $(this).addClass('active');
      $(this).parent().siblings().find('.mega-menu-title').removeClass('active');
      $(this).parent().siblings().find('.mega-dropdown-list ').slideUp();
      $(this).next().slideDown();
    }
    else if ($(this).next().hasClass('active')) {
      $(this).next().removeClass('active');
      $(this).removeClass('active');
      $(this).parent().siblings().find('.mega-menu-title').removeClass('active');
      $(this).parent().siblings().find('.mega-dropdown-list ').slideUp();
      $(this).next().slideUp();
    }
    return false;
  });

  // Tooltips
  $('[data-toggle="tooltip"]').tooltip();

  //Fancybox
  var fancy = $(".fancybox");
  if (fancy.length) {
    fancy.fancybox({
      arrows: true,
      buttons: [
        "zoom",
        "slideShow",
        "thumbs",
        "close"
      ],
      animationEffect: "zoom-in-out",
      transitionEffect: "zoom-in-out",
    });
  }

  //Remove Placeholder When Focus Or Click
  $("input,textarea").each(function () {
    $(this).data('holder', $(this).attr('placeholder'));
    $(this).on('focusin', function () {
      $(this).attr('placeholder', '');
    });
    $(this).on('focusout', function () {
      $(this).attr('placeholder', $(this).data('holder'));
    });
  });

  //Tabs
  $(".tab-wrapper").each(function () {
    if ($(this).find('.tabs').length) {
      /*Tab Element*/
      $(this).find(".tab__content").hide();
      $(this).find(".tab__content:first").show();
      /* if in tab mode */
      $(this).find("ul.tabs li").on('click', function () {
        var activeTab = $(this).attr("rel");
        $("#" + activeTab).siblings(".tab__content").slideUp("fast");
        $("#" + activeTab).slideDown("fast");
        $(this).siblings('li').removeClass("active");
        $(this).addClass("active");
        $(this).parent('.tabs').siblings('.tab_container').find(".tab_drawer_heading").removeClass("d_active");
        $(this).parent('.tabs').siblings('.tab_container').find(".tab_drawer_heading[rel^='" + activeTab + "']").addClass("d_active");
      });
      /* if in drawer mode */
      $(this).find(".tab_drawer_heading").on('click', function () {
        var d_activeTab = $(this).attr("rel");
        $("#" + d_activeTab).siblings(".tab__content").slideUp();
        $("#" + d_activeTab).slideDown();
        $(this).siblings('.tab_drawer_heading').removeClass("d_active");
        $(this).addClass("d_active");
        $(this).parent('.tab_container').siblings('.tabs').find("li").removeClass("active");
        $(this).parent('.tab_container').siblings('.tabs').find("li[rel^='" + d_activeTab + "']").addClass("active");
        scrollVal = $(this).parents('.tab_container').offset().top - header_height();
        $("html, body").animate({ scrollTop: scrollVal }, 1000);
      });
      /* Extra class "tab_last" to add border to right side of last tab */
      $('ul.tabs li').last().addClass("tab_last");
    }
  });

  //Counter Function
  $('.timer').each(function () {
    var timer = $(this);
    if (timer.length) {
      timer.appear(function () {
        timer.countTo();
      });
    }
  });

  //Progress Bar
  $('.progress-bar').each(function () {
    var width = $(this).data('percent');
    $(this).css({ 'transition': 'width 3s' });
    $(this).appear(function () {
      $(this).css('width', width + '%');
      $(this).find('.count').countTo({
        from: 0,
        to: width,
        speed: 3000,
        refreshInterval: 50,
      });
    });
  });

  // Hero Banner
  var heroBanner = $('.hero-banner-slider');
  if (heroBanner.length) {
    if (heroBanner.find('.hero-slide').length > 1) {
      heroBanner.owlCarousel({
        items: 1,
        nav: false,
        dots: true,
        loop: true,
        autoplay: true,
        autoplayTimeout: 6000,
        autoplayHoverPause: false,
        smartSpeed: 800,
        onInitialize: function () {
          if (heroBanner.find('.hero-slide').length === 1) {
            this.settings.loop = false;
            this.settings.nav = false;
          }
        }
      });
    } else {
      heroBanner.show();
    }
  }

  $().fancybox({ selector : '.owl-item:not(.cloned) a' });

  //team Slider
  var teamSlider = $('.team-slider-init');
  if (teamSlider.length) {
    if (teamSlider.find('.team-slide').length > 1) {
      teamSlider.owlCarousel({
        margin: 30,
        nav: false,
        dots: false,
        loop: true,
        autoplay: true,
        autoplayTimeout: 4500,
        autoplayHoverPause: false,
        smartSpeed: 1000,
        responsive: {
          0: {
            items: 1
          },
          575: {
            items: 2
          },
          992: {
            items: 3
          }
        },
        onInitialize: function () {
          if (teamSlider.find('.team-slide').length === 1) {
            this.settings.loop = false;
            this.settings.nav = false;
          }
        }
      });
    } else {
      teamSlider.show();
    }
  }

  //Blog Teaser Slider
  $(".blog-teaser-slider").each(function () {
    var blogTeaserSlider = $(this);
    if (blogTeaserSlider.length) {
      if (blogTeaserSlider.find('.blog-teaser-slide').length > 3) {
        blogTeaserSlider.owlCarousel({
          items: 3,
          margin: 30,
          nav: false,
          dots: false,
          lazyLoad: true,
          autoplay: true,
          loop: true,
          responsive: {
            0: {
              items: 1
            },
            575: {
              items: 2
            },
            992: {
              items: 3
            }
          },
          onInitialize: function () {
            if (blogTeaserSlider.find('.news-overlay-slide').length > 3) {
              $(this).settings.loop = true;
              $(this).settings.nav = true;
            }
          }
        });
      } else {
        blogTeaserSlider.show();
      }
    }
  });
  var teamSlider = $('.team-slider-init');
  if (teamSlider.length) {
    if (teamSlider.find('.team-slide').length > 1) {
      teamSlider.owlCarousel({
        margin: 30,
        nav: false,
        dots: false,
        loop: true,
        autoplay: true,
        autoplayTimeout: 4500,
        autoplayHoverPause: false,
        smartSpeed: 1000,
        responsive: {
          0: {
            items: 1
          },
          575: {
            items: 2
          },
          992: {
            items: 3
          }
        },
        onInitialize: function () {
          if (teamSlider.find('.team-slide').length === 1) {
            this.settings.loop = false;
            this.settings.nav = false;
          }
        }
      });
    } else {
      teamSlider.show();
    }
  }

  //Standard Testimonial
  var testimonialSlider = $('.standard-testimonial-slider');
  if (testimonialSlider.length) {
    if (testimonialSlider.find('.standard-testimonial-slide').length > 1) {
      testimonialSlider.owlCarousel({
        loop: true,
        nav: true,
        dots: false,
        autoplay: true,
        autoplayTimeout: 4000,
        autoplayHoverPause: true,
        responsive: {
          0: {
            items: 1
          },
          768: {
            items: 2
          },
          1024: {
            items: 3
          }
        },
      });
    } else {
      testimonialSlider.show();
    }
  }

  //Classic Testimonial
  var testimonialTslider = $('.classic-testimonial-slider');
  if (testimonialTslider.length) {
    if (testimonialTslider.find('.classic-testimonial-slide').length > 1) {
      testimonialTslider.owlCarousel({
        loop: true,
        nav: true,
        dots: false,
        autoplay: true,
        autoplayTimeout: 4000,
        smartSpeed: 1200,
        autoplayHoverPause: true,
        lazyLoad: true,
        items: 1
      });
    } else {
      testimonialTslider.show();
    }
  }

  //Classic Testimonial v2
  var testimonialClassicSlider = $('.testimonial-boxed-slider');
  if (testimonialClassicSlider.length) {
    if (testimonialClassicSlider.find('.testimonial-boxed-slide').length > 1) {
      testimonialClassicSlider.owlCarousel({
        loop: true,
        nav: false,
        dots: true,
        autoplay: true,
        autoplayTimeout: 4000,
        autoplaySpeed: 1000,
        lazyLoad: true,
        items: 1
      });
    } else {
      testimonialClassicSlider.show();
    }
  }

  // Hover Tilt effect On fancy Teaser
  var fancyTeaserAnimate = $('.fancy-teaser--animate');
  if (fancyTeaserAnimate.length) {
    fancyTeaserAnimate.tilt({
      glare: true,
      maxGlare: 0.4
    });
  }

  // Partner Slider
  var partnerSlider = $('.partner-block--slider');
  if (partnerSlider.length) {
    if (partnerSlider.find('.partner-block__slide').length > 1) {
      partnerSlider.owlCarousel({
        loop: true,
        nav: false,
        dots: false,
        autoplay: true,
        autoplayTimeout: 5000,
        smartSpeed: 1000,
        autoplayHoverPause: true,
        lazyLoad: true,
        center: true,
        responsive: {
          0: {
            items: 2
          },
          576: {
            items: 3
          },
          768: {
            items: 5
          },
          1200: {
            items: 7,
          }
        },
      });
    } else {
      partnerSlider.show();
    }
  }

  //Gallery Slider
  var gallerySlider = $('.gallery-slider');
  if (gallerySlider.length) {
    if (gallerySlider.find('.gallery-slide').length > 1) {
      gallerySlider.owlCarousel({
        margin: 0,
        nav: true,
        dots: false,
        loop: true,
        autoplay: true,
        autoplayTimeout: 4500,
        autoplayHoverPause: false,
        smartSpeed: 1000,
        responsive: {
          0: {
            items: 1
          },
          575: {
            items: 2
          },
          992: {
            items: 3
          }
        },
        onInitialize: function () {
          if (gallerySlider.find('.gallery-slide').length === 1) {
            this.settings.loop = false;
            this.settings.nav = false;
          }
        }
      });
    } else {
      gallerySlider.show();
    }
  }

  // code for custom down
  $('.custom-dropdown-wrap .selected-val').on('click', function () {
    $('.header-main').removeClass('search-show');
    $('body').removeClass('menu--open');
    $(this).parent().find('.custom-dropdown').slideToggle('fast').toggleClass('active');
    $(this).parent().toggleClass('open');
  });
  $('.custom-dropdown a').on('click', function (event) {
    $(this).parent().parent().slideUp().removeClass('active');
    $(this).parents('.custom-dropdown-wrap').removeClass('open');
  });
});

$(window).on('resize', function () {
  nav_height();
  mainTopSpace();
});

$(window).on('load', function () {
  //Preloader JS code
  setTimeout(remove_loader, 700);

  //isotope gallery
  isotope_masonry();
  portfolio_filter();

  //Main top spacing
  mainTopSpace();

  // AOS Animation
  if ($("[data-aos]").length) {
    AOS.init({
      disable: 'mobile'
    });
  }
});

var stickyOffset = $('header').height();
var previousScroll = 0;
$(window).on('scroll', function () {
  var sticky = $('header.page'),
    scroll = $(window).scrollTop();

  if (scroll >= header_height()) sticky.addClass('fixed');
  else sticky.removeClass('fixed');

  /* for go to top arrow */
  var currentScroll = $(this).scrollTop();
  if (currentScroll > previousScroll) {
    if (scroll >= stickyOffset + 100) {
      $('.goto-top').addClass('visible');
    }
  } else {
    $('.goto-top').removeClass('visible');
  }
});

$(document).on("touchstart click", function (e) {
  container = $('.mobile-search-wrap, .custom-dropdown-wrap, .navigation-icons');
  contactInfo = $('.search-btn');
  if (!container.is(e.target) // if the target of the click isn't the container...
    && container.has(e.target).length === 0 && !contactInfo.is(e.target) && contactInfo.has(e.target).length === 0) {
    // Action Which you want to perform
    $('.header-main').removeClass('search-show');
    $('.custom-dropdown-wrap').removeClass('open');
    $('.custom-dropdown-wrap .custom-dropdown').slideUp();
  }
});

var DELAY = 500,
  clicks = 0,
  timer = null;
function isTouchDevice() {
  return true == ("ontouchstart" in window || window.DocumentTouch && document instanceof DocumentTouch);
}
$(document).on("click", ".has-sub-menu > a", function (e) {
  if (isTouchDevice() === true && (window.matchMedia('(min-width: 993px)').matches) && (window.matchMedia('(max-width: 1200px)').matches)) {
    clicks++;
    if (clicks === 1) {
      timer = setTimeout(function () {
        clicks = 0;
      }, DELAY);
      e.preventDefault();
    } else {
      clearTimeout(timer);
      clicks = 0;
    }
  }
}).on("dblclick", function (e) { });

function nav_height() {
  if (window.matchMedia('(min-width: 991px)').matches) {
    $('.navigation').css('min-height', 'auto');
    $('.navigation').css('margin-top', 0);
  } else {
    $('.navigation').css('min-height', win_height() - header_height() + 1);
    $('.navigation').css('margin-top', header_height() - 1);
  }
}

function win_height() {
  return $(window).outerHeight();
}

function win_width() {
  return $(window).width();
}

function header_height() {
  return $('header.page').outerHeight();
}

function mainTopSpace() {
  //Main top Spacing
  setTimeout(function () {
    $('main:not(".transparent-header")').css('margin-top', header_height());
  }, 700);
}

function remove_loader() {
  $('.preloader').hide();
}

/*isotope_masonry Function*/
function isotope_masonry() {
  //portfolio Isotope plugins initialize
  if ($('.news-grid').length) {
    $NewsGrid = $('.news-grid').isotope({
      itemSelector: '.news-grid__item',
      layoutMode: "packery",
      getSortData: {
        dateby: '.news-date',
        filename: '.news-title',
      }
    });
    var $img = $('img');
    $NewsGrid.imagesLoaded(function () {
      $img.on('load', function () {
        $NewsGrid.isotope('layout');
      });
    });

    // filter items on button click
    $('.blog-filter-nav').on('click', 'li', function () {
      var filterValue = $(this).attr('data-filter');
      $NewsGrid.isotope({
        filter: filterValue
      });
      $('.blog-filter-nav li').removeClass('is-active');
      $(this).addClass('is-active');
    });
  }
}

// portfolio filter
function portfolio_filter() {
  if ($('.portfolio--row').length) {
    $portfolioGrid = $('.portfolio--row').isotope({
      itemSelector: '.portfolio-item',
      layoutMode: "packery",
    });

    var $img = $('img');
    $portfolioGrid.imagesLoaded(function () {
      $img.on('load', function () {
        $portfolioGrid.isotope('layout');
      });
    });

    $('.portfolio-filter').on('click', '.portfolio-filter__item', function () {
      var filterValue = $(this).attr('data-filter');
      $portfolioGrid.isotope({
        filter: filterValue
      });
      $('.portfolio-filter .portfolio-filter__item').removeClass('portfolio-filter__item--active');
      $(this).addClass('portfolio-filter__item--active');
    });
  }
}
